import React, { Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import reportWebVitals from './reportWebVitals';

// reportWebVitals();

import Accueil from "./FLAGS-GAME/Accueil";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Fragment>
    <Accueil/>
  </Fragment>
)
